import { G, Path, Svg } from "@react-pdf/renderer"

type BriefCaseIconPDFProps = {
	width?: number
	height?: number
	stroke?: string
	fill?: string
	opacity?: number
}

export const BriefCaseIconPDF: React.FC<BriefCaseIconPDFProps> = ({
	width = 16,
	height = 16,
	stroke = "#020617",
	fill,
	opacity = 0.5,
}) => {
	return (
		<Svg width={width} height={height} viewBox="0 0 16 16" fill={fill}>
			<G opacity={opacity}>
				<Path
					d="M13.3335 4.66663H2.66683C1.93045 4.66663 1.3335 5.26358 1.3335 5.99996V12.6666C1.3335 13.403 1.93045 14 2.66683 14H13.3335C14.0699 14 14.6668 13.403 14.6668 12.6666V5.99996C14.6668 5.26358 14.0699 4.66663 13.3335 4.66663Z"
					stroke={stroke}
					strokeWidth="1.33"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<Path
					d="M10.6668 14V3.33333C10.6668 2.97971 10.5264 2.64057 10.2763 2.39052C10.0263 2.14048 9.68712 2 9.3335 2H6.66683C6.31321 2 5.97407 2.14048 5.72402 2.39052C5.47397 2.64057 5.3335 2.97971 5.3335 3.33333V14"
					stroke={stroke}
					strokeWidth="1.33"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</G>
		</Svg>
	)
}
